import React from 'react';

const labels = {
  inOrder: 'Steps must be taken in order',
  anyOrder: 'Steps can be taken in any order',
};

const StepOrder = ({ enforcedOrder = false }) => (
  <div className="PathContent-stepOrder fz-bigger c-gray-darker mb-8">
    {labels[enforcedOrder ? 'inOrder' : 'anyOrder']}
  </div>
);

export default StepOrder;
